import Input from "../../atoms/input/input";
import PretendardText from "../../atoms/text/pretendardText";
import TextArea from "../../atoms/input/textarea";

import useDisplay from "../../../hooks/useDisplay";
import LSBdH1HeadLine from "../text/linSeedKr/Bd/lsBdH1HeadLine";
import LSRgBody01 from "../text/linSeedKr/Rg/lsRgBody01";
import LSRgCaption02 from "../text/linSeedKr/Rg/lsRgCaption02";

function TitleInput({
  style,
  title,
  essential,
  value,
  onChange,
  type,
  placeholder,
  maxLength,
  disabled,
  warningMessage,
  guideMessage,
  checkMessage,
  inputStyle,
  onKeyDown,
  inputType,
  setInputType,
  isRightButton,
  isRightButtonText,
  isRightButtonStyle,
  isTimer,
  timerStyle,
  isTextarea,
  rightButtonOnClick,
  min,
  sec,
  autocomplete,
}) {
  const { isMobile, isTablet, isDesktop } = useDisplay();

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          ...style,
        }}
      >
        <div
          style={{
            marginBottom: 4,
            display: "flex",
            flexDirection: "row",
          }}
        >
          <LSBdH1HeadLine
            style={{
              color: disabled ? "#ABABAB" : "#101113",
            }}
          >
            {title}
          </LSBdH1HeadLine>
          {essential ? (
            <div
              style={{
                width: 4,
                height: 4,
                borderRadius: 999,
                background: "#F24147",
                marginLeft: 2,
              }}
            />
          ) : null}
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            position: "relative",
            flex: 1,
          }}
        >
          <div
            style={{
              width: "100%",
            }}
          >
            <div
              style={{
                width: "100%",
                position: "relative",
              }}
            >
              {isTextarea ? (
                <TextArea
                  value={value}
                  onChange={onChange}
                  type={type}
                  placeholder={placeholder}
                  style={{
                    flex: 1,
                    borderColor: warningMessage ? "#FF5A5A" : "#e8e8e8",
                    ...inputStyle,
                  }}
                />
              ) : (
                <Input
                  value={value}
                  onChange={onChange}
                  type={type}
                  placeholder={placeholder}
                  maxLength={maxLength}
                  disabled={disabled}
                  style={{
                    flex: 1,
                    borderColor: warningMessage ? "#FF5A5A" : "#e8e8e8",
                    ...inputStyle,
                  }}
                  onKeyDown={onKeyDown}
                  autocomplete={autocomplete}
                />
              )}

              {isTimer ? (
                <div
                  style={{
                    position: "absolute",
                    cursor: "pointer",
                    right: "10%",
                    top: "50%",
                    transform: "translate(-50%, -50%)",
                    padding: "4px 10px",
                    borderRadius: 6,
                    ...timerStyle,
                  }}
                >
                  <PretendardText
                    style={{
                      fontWeight: 600,
                      fontSize: 12,
                      lineHeight: "16.8px",
                      color: "#FF3D83",
                    }}
                  >
                    {min}:{sec < 10 ? "0" + sec : sec}
                  </PretendardText>
                </div>
              ) : null}

              {isRightButton ? (
                <div
                  onClick={rightButtonOnClick}
                  style={{
                    position: "absolute",
                    cursor: "pointer",
                    right: "-5%",
                    top: "50%",
                    transform: "translate(-50%, -50%)",
                    background: "#101113",
                    padding: "6px 8px",
                    borderRadius: 8,
                    ...isRightButtonStyle,
                  }}
                >
                  <LSRgBody01
                    style={{
                      color: "#FFFFFF",
                    }}
                  >
                    {isRightButtonText}
                  </LSRgBody01>
                </div>
              ) : null}
            </div>

            {guideMessage ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  marginTop: 4,
                }}
              >
                <img
                  style={{
                    widows: 14,
                    height: 14,
                    marginRight: 3,
                  }}
                  src="/assets/icons/warning.png"
                />
                <LSRgCaption02
                  style={{
                    color: "#A4A8B1",
                  }}
                >
                  {guideMessage}
                </LSRgCaption02>
              </div>
            ) : null}

            {warningMessage ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  marginTop: 4,
                }}
              >
                <img
                  style={{
                    widows: 14,
                    height: 14,
                    marginRight: 3,
                  }}
                  src="/assets/icons/warning_r.png"
                />
                <LSRgCaption02
                  style={{
                    color: "#F24147",
                  }}
                >
                  {warningMessage}
                </LSRgCaption02>
              </div>
            ) : null}

            {checkMessage ? (
              <LSRgCaption02
                style={{
                  color: "#000075",
                  marginTop: 4,
                }}
              >
                {checkMessage}
              </LSRgCaption02>
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
}

export default TitleInput;
